module.exports = {
  realm: 'SE',
  market: 'sv-SE',
  domain: 'viktvaktarna.se',
  vsDomain: 'viktvaktarna.se',
  countryId: '28000',
  vsPath: 'se',
  spiceLocale: 'se',
  vsUrl: 'https://www{env}viktvaktarna.se/se',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/se/messages/',
  cmxSiteUrl: 'https://cmx{env}viktvaktarna.se/',
  currency: 'kr',
  decimalSeparator: ',',
  thousandSeparator: '.',
  currencyFormat: '%number kr',
  dateFormat: 'yyyy-MM-dd',
  loginApiUrl: 'https://auth{env}viktvaktarna.se/login-apis/',
  loginWebUrl: 'https://auth{env}viktvaktarna.se/v2/login/',
  countryCode: 'SE',
  commUlr: 'https://commerce{env}weightwatchers.com/se/sv/api/',
  timezone1: 'Europe/Stockholm',
  timezone2: '+01:00',
};
